import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicService } from '../public.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  constructor(public publicservice : PublicService, public router: Router) { }

  ngOnInit(): void {
  }

  backhome() {
    this.router.navigate(['home']);
  }

}
